// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"ModalWrapperV3_modal-wrapper__bRfyb"};